import type { ReportDefinitionSummary, ReportDefinitionTenant } from './api';

/** O cliente de uma linha, com o nome que a tela mostra: o id quando o tenant não tem nome no banco. */
export class ReportLineTenant {
  static of(line: ReportDefinitionSummary): ReportDefinitionTenant {
    return { tenantId: line.tenantId, name: line.tenantName ?? line.tenantId };
  }
}
